export default __webpack_public_path__ + "media/images/clippy_wave.gif";